/* eslint-disable @typescript-eslint/no-unused-vars */
import type {
  BlockRequestParams,
  ChannelsResponseData,
  ChannelDetailResponseDataV2,
  LeaveChannelResponseData,
  ReadAnnouncementResponse,
  ReportRequestParams,
  ReportResponseData,
  UsersMeResponseData,
} from '@myrealtrip/messenger-core';

import { messengerRequest } from './_client';

export interface ChannelsRequestParams {
  gid: string | number | null;
  partnerId: number;
}

export interface AttachmentUploadResponse {
  data: { ids: number[] };
}

export { MrtAxiosException } from '../mrt-error';

export const fetchChannelDetail = async (channelId: string, _options?: unknown) =>
  messengerRequest<{ data: ChannelDetailResponseDataV2 }>(`/traveler/v2/channels/${channelId}`);
export const joinChannel = async (channelUrl: string, _options?: unknown) =>
  messengerRequest(`/traveler/v2/channels/${channelUrl}/join`, { method: 'POST' });
export const fetchMyChannels = (_options?: unknown) => () =>
  messengerRequest<{ data: any[] }>(`/traveler/v2/my-channels`);
export const fetchMyChannelsByUrls = (channelUrls: string[], _options?: unknown) =>
  messengerRequest<{ data: any[] }>(`/traveler/v2/my-channels`, {
    method: 'POST',
    body: JSON.stringify({ channelUrls }),
  });
export const fetchChannelEnrichments = (channelUrls: string[], _options?: unknown) =>
  messengerRequest<{
    data: Array<{ channelUrl: string; coverUrl: string | null; messengerGroupType: string }>;
  }>(`/traveler/v2/channels/enrichment`, { method: 'POST', body: JSON.stringify({ channelUrls }) });
export const fetchUsersMe = (_options?: unknown) => async () => {
  const res = await messengerRequest<UsersMeResponseData>(`/traveler/v1/users/me`);
  return { data: res.data };
};
export const fetchChannels = (params: ChannelsRequestParams, _options?: unknown) => () =>
  messengerRequest<{ data: ChannelsResponseData }>(`/traveler/v1/channels`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
export const fetchLeaveChannel = (channelId: string, _options?: unknown) =>
  messengerRequest<{ data: LeaveChannelResponseData }>(`/traveler/v1/channels/${channelId}`, {
    method: 'DELETE',
  });
export const fetchKickUser = (
  params: { channelUrl: string; sendbirdId: string },
  _options?: unknown,
) =>
  messengerRequest<{ data: LeaveChannelResponseData }>(
    `/traveler/v2/channels/${params.channelUrl}/drop`,
    { method: 'POST', body: JSON.stringify({ dropSendbirdUserId: params.sendbirdId }) },
  );
export const fetchReport = (params: ReportRequestParams, _options?: unknown) =>
  messengerRequest<{ data: ReportResponseData }>(`/traveler/v1/users/report`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
export const uploadReportFiles = (params: FormData, _options?: unknown) =>
  messengerRequest<AttachmentUploadResponse>(`/images`, {
    method: 'POST',
    body: params,
    headers: {},
  });
export const fetchBlock = (params: BlockRequestParams, _options?: unknown) =>
  messengerRequest<{ data: ReportResponseData }>(`/traveler/v1/users/block`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
export const fetchReadAnnouncement = (channelId: string, _options?: unknown) =>
  messengerRequest<{ data: ReadAnnouncementResponse }>(
    `/traveler/v1/channels/${channelId}/announcements/read`,
    { method: 'POST' },
  );
export const fetchInvitePartner = (channelUrl: string, _options?: unknown) =>
  messengerRequest<{ data: ReadAnnouncementResponse }>(`/traveler/v1/channels/invitation`, {
    method: 'POST',
    body: JSON.stringify({ channelUrl }),
  });
